import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Accordion, AccordionSummary, AccordionDetails } from '@availity/element';
import CommonStore from '../../stores/CommonStore';

const Footer = ({ commonStore }) => {
  const { termsOfUse } = commonStore;
  const [isExpanded, setIsExpanded] = useState(false);

  const handleChange = (event, expanded) => {
    setIsExpanded(expanded);
  };

  return (
    <Accordion
      sx={{ mt: 2 }}
      expanded={isExpanded}
      onChange={handleChange}
      id="footer-accordion" 
    >
      <AccordionSummary
        aria-controls='panel-content'
        id='panel-header'
      >
        Terms of Use
      </AccordionSummary>
      <AccordionDetails id="footer-accordion-details"> 
        <div
          id="footer-terms-of-use" 
          dangerouslySetInnerHTML={{ __html: termsOfUse }}
        />
      </AccordionDetails>
    </Accordion>
  );
};

export default Footer;

Footer.propTypes = {
  commonStore: PropTypes.instanceOf(CommonStore).isRequired,
};